module.exports = __webpack_public_path__ + "img/withdraw.df48da6a.png";